import React from "react";
import PageSeo from "components/Seo/PageSeo";
import { useSelector } from "react-redux";
import PageHero from "components/PageHero/PageHero";
import EventCard from "components/EventsPage/EventCard";
import "components/Home/homeShared.css";
import "./events.css";

const Events = () => {
  const events = useSelector((state) => state.contentfulReducer.events);

  return (
    <main className="events-page">
      <PageSeo
        title="Gymnastics Events"
        description="Open gyms, birthday parties, exhibitions, and special activities at Ace Gymnastics in Bardstown, KY."
        path="/events"
      />

      <PageHero
        title="Events"
        subtitle="Open gyms, birthday parties, exhibitions, and special activities for the whole family."
        imageAlt="Ace Gymnastics events"
      />

      <section
        className="events-page__content home-section"
        aria-label="Gymnastics events"
      >
        <div className="home-section__inner">
          {events.length === 0 ? (
            <p className="events-page__empty">
              Event listings are loading. Please check back shortly.
            </p>
          ) : (
            <>
              <p className="events-page__intro">
                Join us for fun beyond regular classes. Tap{" "}
                <strong>View details</strong> on any event for dates, times,
                pricing, and registration.
              </p>
              <div className="events-page__grid">
                {events.map((event) => (
                  <EventCard key={event.sys?.id || event.fields.name} event={event} />
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </main>
  );
};

export default Events;
